// Las pantallas leen el logo de sucursal.logoUrl (columna sucursales.logo_url); se sube desde Sucursales.

/** Devuelve la URL del logo configurado o null (la UI muestra el ícono genérico). */
export function getSucursalImage(sucursal) {
  return sucursal?.logoUrl || null;
}
